import { Loader } from 'google-maps';

import config from '../config';

/**
 * To use in a Vue component, add the AddressAutocompleteMixin. Then use;
 * 
 * this.GoogleMapsApi.useAutocomplete('fieldSelector', (autocomplete) => { ... }))
 * 
 * this.GoogleMapsApi.cleanupAutocomplete('fieldSelector')
 * 
 */
class GoogleMapsApi{
  google = null;
  autocomplete = {};
  constructor(libraries){
    this.loader = new Loader(config.GOOGLE_MAPS_BROWSER_API_KEY, {
      libraries,
    });
    this.googlePromise = this.loader.load();
    this.googlePromise.then(google => {
      this.google = google;
    });
  }

  /**
   * Address Autocompletion example: https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
   */

  async useBrowserLocation(autocomplete) {
    if (navigator.geolocation) {
      if(this.google === null) await this.googlePromise;
      navigator.geolocation.getCurrentPosition((position) => {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        console.log("useBrowserLocation geolocation", geolocation);
        var circle = new this.google.maps.Circle(
            {center: geolocation, radius: position.coords.accuracy});
        autocomplete.setBounds(circle.getBounds());
      });
    }else{
      console.log("useBrowserLocation: Browser Location not available");
    }
  }

  async useAutocomplete(fieldSelector, placeChangedCallback){
    if(this.google === null) await this.googlePromise;
    console.log("useAutoComplete", fieldSelector, this.google);

    this.autocomplete[fieldSelector] = new this.google.maps.places.Autocomplete(document.getElementById(fieldSelector));
    
    await this.useBrowserLocation(this.autocomplete[fieldSelector]);

    this.autocomplete[fieldSelector].setFields([
      'address_component', // Provides Street, City, Country etc.
      'geometry', // Lat, Lng
      'formatted_address' // Full Address String
    ]);

    this.autocomplete[fieldSelector].addListener('place_changed', () => placeChangedCallback(this.autocomplete[fieldSelector]));
  }
  async cleanupAutocomplete(fieldSelector){
    delete this.autocomplete[fieldSelector];
  }
  /**
   * Translate Google maps API's address components into our form's field names.
   * Sample component 'types':
   * "street_number"
   * "route"
   * "locality"
   * "administrative_area_level_1"
   * "postal_code"
   * "country"
   * @param {*} autocomplete 
   */
  getAddressComponents(autocomplete){
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    console.log("getAddressComponents", place);
    const address = {
      address: `${this.getLongAddressComponent(place.address_components, 'street_number')} ${this.getLongAddressComponent(place.address_components, 'route')}`,
      city: this.getLongAddressComponent(place.address_components, 'locality'),
      province: `${this.getShortAddressComponent(place.address_components, 'administrative_area_level_1')}`,
      postal: `${this.getLongAddressComponent(place.address_components, 'postal_code')}`,
      country: `${this.getLongAddressComponent(place.address_components, 'country')}`,
    };
    return address;
  }

  /**
   * @param {*} autocomplete 
   */
  getAddressCoordinates(autocomplete){
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    console.log("getAddressCoordinates", place.geometry);
    return {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
  }

  /**
   * @param {*} autocomplete 
   */
  getFullAddressString(autocomplete){
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    console.log("getFullAddressString", place.formatted_address);
    return place.formatted_address;
  }

  getLongAddressComponent(address_components, type){
    const addressComponent = address_components.find(component => {
      return component.types.indexOf(type) !== -1;
    });
    if(addressComponent){
      return addressComponent.long_name;
    }else{
      return '';
    }
  }
  getShortAddressComponent(address_components, type){
    const addressComponent = address_components.find(component => {
      return component.types.indexOf(type) !== -1;
    });
    if(addressComponent){
      return addressComponent.short_name;
    }else{
      return '';
    }
  }

}

export default new GoogleMapsApi(["places"]);


// WEBPACK FOOTER //
// ./src/utils/GoogleMapsApi.js